import type { WorkingUnitsNumber } from "../../common";
import type { ProductPricingData } from "./product-pricing-data.type";
import type { ServiceProductConfigJSON } from "./service-product-config.json";

export class ProductAndQuantityEntryJSON {
  baseProductName: string;
  quantity: number;
}

export class PlansConfigJSON {
  // used to identify the plan programmatically, as well as
  // to select the correct human-readable titles /
  // descriptions in user interfaces
  identifier: string;

  products: ProductAndQuantityEntryJSON[];

  stripeProductId: string;
}

export class PresetProductConfigJSON {
  plans: PlansConfigJSON[];
}

export class OptionsConfigJSON {
  identifier: string;

  baseProductName: string;

  // The increment to use when the user clicks a "+" or "-" button
  defaultIncrement: number;
}

export class CustomProductConfigJSON {
  options: OptionsConfigJSON[];
}

export type OptionsConfigWithPrice = OptionsConfigJSON & {
  price: number;
};

export type PlansConfigWithPrice = PlansConfigJSON & {
  price: number;
};

export type CustomProductConfigWithPrices = {
  options: OptionsConfigWithPrice[];
};

export type PresetProductConfigWithPrices = {
  plans: PlansConfigWithPrice[];
};

export type UsageProductConfigWithPrices = {
  options: { identifier: string; price: WorkingUnitsNumber }[];
  flatFee: WorkingUnitsNumber;
};

export class UsageProductConfigJSON {
  usage: {
    source: "ecommerce_integration";
    productsPerUnit: ProductAndQuantityEntryJSON[];
    flatFee?: { stripeProductId: string; pricing: ProductPricingData };
  };
}

export class OfferProductConfigJSON {}
export class UnrecognisedProductConfigJSON {}

export type ImpactProductConfigJSON =
  | PresetProductConfigJSON
  | CustomProductConfigJSON
  | UsageProductConfigJSON
  | OfferProductConfigJSON;

// all product configs
export type ProductConfigJSON =
  | ImpactProductConfigJSON
  | ServiceProductConfigJSON
  | UnrecognisedProductConfigJSON;
